//
//  src/layouts/default/contact/form/error/Error.js
//
import * as React from "react";
import EnquireOutcomeError from "../../../../../components/enquire/EnquireOutcomeError";
import "./Error.css";

export default function FormError() {
    return (
        <EnquireOutcomeError
            source="form"
            subtitle="Message Not Received"
            message={
                <p>
                    The server has encountered an unexpected error.<br />
                    Please contact me directly at{" "}
                    <a href="mailto:jeff@jefftattooer.com">jeff@jefftattooer.com</a>.
                </p>
            }
        />
    );
}
